// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Border UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  --ezBorderColorBlack: var(--ezClockerBlack);
  --ezBorderColorGray: var(--ezClockerGray);
  --ezBorderColorStone: var(--ezClockerStone);
  --ezBorderColorSilver: var(--ezClockerSilver);
  --ezBorderColorOffWhite: var(--ezClockerOffWhite);
  --ezBorderColorNavy: var(--ezClockerNavy);
  --ezBorderStyle: solid;
  --ezBorderWidth: 1px;
  --ezBorderRadius: 3px;
  --ezBorderMedium: 3px;
  --ezBorderMediumRadius: 3px;
  --ezBorderThick: 4px;
  --ezBorderThickRadius: 3px;
}

.ezBorders-radius {
  border-radius: var(--ezBorderRadius);
}

.ezBorders-top-radius {
  border-top-left-radius: var(--ezBorderRadius);
  border-top-right-radius: var(--ezBorderRadius);
}

.ezBorders-bottom-radius {
  border-bottom-left-radius: var(--ezBorderRadius);
  border-bottom-right-radius: var(--ezBorderRadius);
}

/* 1px borders */
.ezBorder {
  border-color: var(--ezBorderColorGray);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ez-border-rounded {
  border-color: var(--ezBorderColorGray);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
  border-radius: var(--ezBorderRadius);
}

.ez-border-navy {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
  border-radius: var(--ezBorderRadius);
}

.ez-border-navy-2px {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: 2px;
  border-radius: var(--ezBorderRadius);
}

.ez-border-medium-navy {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderMedium);
  border-radius: var(--ezBorderRadius);
}

.ez-border-medium-rounded-navy {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderMedium);
  border-radius: var(--ezBorderRadius);
}

.ez-border-medium-rounded-right-navy {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderMedium);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: var(--ezBorderRadius);
  border-bottom-right-radius: var(--ezBorderRadius);
}

.ez-border-thick-navy {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderThick);
  border-radius: var(--ezBorderRadius);
}

.ezBorders_Stone {
  border-color: var(--ezBorderColorStone);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ezBorders_Silver {
  border-color: var(--ezBorderColorStone);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ezBorders_OffWhite {
  border-color: var(--ezBorderColorStone);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ezBorderLeft {
  border-color: var(--ezClockerGray);
  border-left-style: var(--ezBorderStyle);
  border-left-width: var(--ezBorderWidth);
}

.ezBorderLeftBottom {
  border-color: var(--ezClockerGray);
  /* border-left-style: var(--ezBorderStyle); */
  border-left-style: var(--ezBorderStyle);
  /* border-left-width: var(--ezBorderWidth) */
  border-left-width: var(--ezBorderWidth);
  /* border-bottom-style: var(--ezBorderStyle); */
  border-bottom-style: var(--ezBorderStyle);
  /* border-bottom-width: var(--ezBorderWidth) */
  border-bottom-width: var(--ezBorderWidth);
}

.ezBorderRight {
  border-color: var(--ezClockerGray);
  border-right-style: var(--ezBorderStyle);
  border-right-width: var(--ezBorderWidth);
}

.ezBorderBottom {
  border-color: var(--ezClockerGray);
  border-right-style: var(--ezBorderStyle);
  border-right-width: var(--ezBorderWidth);
  border-bottom-style: var(--ezBorderStyle);
  border-bottom-width: var(--ezBorderWidth);
}

.ezBorderLeftRightBottom {
  border-color: var(--ezClockerGray);
  border-left-style: var(--ezBorderStyle);
  border-left-width: var(--ezBorderWidth);
  border-right-style: var(--ezBorderStyle);
  border-right-width: var(--ezBorderWidth);
  border-bottom-style: var(--ezBorderStyle);
  border-bottom-width: var(--ezBorderWidth);
}

.ezSolidBorder1 {
  border-color: var(--ezClockerGray);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ezSolidBorderTop1 {
  border-color: var(--ezClockerGray);
  border-top-style: var(--ezBorderStyle);
  border-top-width: var(--ezBorderWidth);
}

.ezSolidBorderBottom1 {
  border-color: var(--ezClockerGray);
  border-bottom-style: var(--ezBorderStyle);
  border-bottom-width: var(--ezBorderWidth);
}

.ezSolidBorderTopBottom1 {
  border-color: var(--ezClockerGray);
  border-top-style: var(--ezBorderStyle);
  border-top-width: var(--ezBorderWidth);
  border-bottom-style: var(--ezBorderStyle);
  border-bottom-width: var(--ezBorderWidth);
}

.ezSolidBorderLeft1 {
  border-color: var(--ezClockerGray);
  border-left-style: var(--ezBorderStyle);
  border-left-width: var(--ezBorderWidth);
}

.ezSolidBorderRight1 {
  border-color: var(--ezClockerGray);
  border-right-style: var(--ezBorderStyle);
  border-right-width: var(--ezBorderWidth);
}

.ezSolidBorderLeftRigt1 {
  border-color: var(--ezClockerGray);
  border-left-style: var(--ezBorderStyle);
  border-left-width: var(--ezBorderWidth);
  border-right-style: var(--ezBorderStyle);
  border-right-width: var(--ezBorderWidth);
}

/* 2px borders */
.ezSolidBorder2 {
  border-color: var(--ezClockerGray);
  border-style: var(--ezBorderStyle);
  border-width: 2px;
}

.ezSolidBorderTop2 {
  border-color: var(--ezClockerGray);
  border-top-style: var(--ezBorderStyle);
  border-top-width: 2px;
}

.ezSolidBorderBottom2 {
  border-color: var(--ezClockerGray);
  border-bottom-style: var(--ezBorderStyle);
  border-bottom-width: 2px;
}

.ezSolidBorderTopBottom2 {
  border-color: var(--ezClockerGray);
  border-top-style: var(--ezBorderStyle);
  border-top-width: 2px;
  border-bottom-style: var(--ezBorderStyle);
  border-bottom-width: 2px;
}

.ezSolidBorderLeft2 {
  border-color: var(--ezClockerGray);
  border-left-style: var(--ezBorderStyle);
  border-left-width: 2px;
}

.ezSolidBorderRight2 {
  border-color: var(--ezClockerGray);
  border-right-style: var(--ezBorderStyle);
  border-right-width: 2px;
}

.ezSolidBorderLeftRigt2 {
  border-color: var(--ezClockerGray);
  border-left-style: var(--ezBorderStyle);
  border-left-width: 2px;
  border-right-style: var(--ezBorderStyle);
  border-right-width: 2px;
}

/* 4px borders */
.ezSolidBorder4 {
  border-color: var(--ezClockerGray);
  border-style: var(--ezBorderStyle);
  border-width: 4px;
}

.ezSolidBorderTop4 {
  border-color: var(--ezClockerGray);
  border-top-style: var(--ezBorderStyle);
  border-top-width: 4px;
}

.ezSolidBorderBottom4 {
  border-color: var(--ezClockerGray);
  border-bottom-style: var(--ezBorderStyle);
  border-bottom-width: 4px;
}

.ezSolidBorderTopBottom4 {
  border-color: var(--ezClockerGray);
  border-top-style: var(--ezBorderStyle);
  border-top-width: 4px;
  border-bottom-style: var(--ezBorderStyle);
  border-bottom-width: 4px;
}

.ezSolidBorderLeft4 {
  border-color: var(--ezClockerGray);
  border-left-style: var(--ezBorderStyle);
  border-left-width: 4px;
}

.ezSolidBorderRight4 {
  border-color: var(--ezClockerGray);
  border-right-style: var(--ezBorderStyle);
  border-right-width: 4px;
}

.ezSolidBorderLeftRigt4 {
  border-color: var(--ezClockerGray);
  border-left-style: var(--ezBorderStyle);
  border-left-width: 4px;
  border-right-style: var(--ezBorderStyle);
  border-right-width: 4px;
}

.ezRadius2 {
  border-radius: 2px;
}

.ezRadiusTopLeft2 {
  border-top-left-radius: 2px;
}

.ezRadisuTopRight2 {
  border-top-right-radius: 2px;
}

.ezRadiusTop2 {
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

.ezRadiusBottomLeft2 {
  border-bottom-left-radius: 2px;
}

.ezRadisuBottomRight2 {
  border-bottom-right-radius: 2px;
}

.ezRadisuBottom2 {
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ezRadiusLeft2 {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ezRadiusRight2 {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ezRadius4 {
  border-radius: 4px;
}

.ezRadiusTopLeft4 {
  border-top-left-radius: 4px;
}

.ezRadiusTopRight4 {
  border-top-right-radius: 4px;
}

.ezRadiusTop4 {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.ezRadiusBottomLeft4 {
  border-bottom-left-radius: 4px;
}

.ezRadisuBottomRight4 {
  border-bottom-right-radius: 4px;
}

.ezRadisuBottom4 {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.ezRadiusLeft4 {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.ezRadiusRight4 {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-borders.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,2CAAA;EACA,yCAAA;EACA,2CAAA;EACA,6CAAA;EACA,iDAAA;EACA,yCAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,2BAAA;EACA,oBAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,oCAAA;AAAJ;;AAGA;EACI,6CAAA;EACA,8CAAA;AAAJ;;AAGA;EACI,gDAAA;EACA,iDAAA;AAAJ;;AAIA,gBAAA;AACA;EACI,sCAAA;EACA,kCAAA;EACA,kCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,iBAAA;EACA,oCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,mCAAA;EACA,oCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,mCAAA;EACA,oCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,mCAAA;EACA,yBAAA;EACA,4BAAA;EACA,8CAAA;EACA,iDAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;AADJ;;AAIA;EACI,uCAAA;EACA,kCAAA;EACA,kCAAA;AADJ;;AAIA;EACI,uCAAA;EACA,kCAAA;EACA,kCAAA;AADJ;;AAIA;EACI,uCAAA;EACA,kCAAA;EACA,kCAAA;AADJ;;AAIA;EACI,kCAAA;EACA,uCAAA;EACA,uCAAA;AADJ;;AAIA;EACI,kCAAA;EAEA,6CAAA;EACA,uCAAA;EAEA,4CAAA;EACA,uCAAA;EAEA,+CAAA;EACA,yCAAA;EAEA,8CAAA;EACA,yCAAA;AALJ;;AAQA;EACI,kCAAA;EACA,wCAAA;EACA,wCAAA;AALJ;;AAQA;EACI,kCAAA;EACA,wCAAA;EACA,wCAAA;EACA,yCAAA;EACA,yCAAA;AALJ;;AAQA;EACI,kCAAA;EACA,uCAAA;EACA,uCAAA;EACA,wCAAA;EACA,wCAAA;EACA,yCAAA;EACA,yCAAA;AALJ;;AAQA;EACI,kCAAA;EACA,kCAAA;EACA,kCAAA;AALJ;;AAQA;EACI,kCAAA;EACA,sCAAA;EACA,sCAAA;AALJ;;AAQA;EACI,kCAAA;EACA,yCAAA;EACA,yCAAA;AALJ;;AAQA;EACI,kCAAA;EACA,sCAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;AALJ;;AAQA;EACI,kCAAA;EACA,uCAAA;EACA,uCAAA;AALJ;;AAQA;EACI,kCAAA;EACA,wCAAA;EACA,wCAAA;AALJ;;AAQA;EACI,kCAAA;EACA,uCAAA;EACA,uCAAA;EACA,wCAAA;EACA,wCAAA;AALJ;;AAQA,gBAAA;AACA;EACI,kCAAA;EACA,kCAAA;EACA,iBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,sCAAA;EACA,qBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,yCAAA;EACA,wBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,sCAAA;EACA,qBAAA;EACA,yCAAA;EACA,wBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,uCAAA;EACA,sBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,wCAAA;EACA,uBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,uCAAA;EACA,sBAAA;EACA,wCAAA;EACA,uBAAA;AALJ;;AAQA,gBAAA;AACA;EACI,kCAAA;EACA,kCAAA;EACA,iBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,sCAAA;EACA,qBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,yCAAA;EACA,wBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,sCAAA;EACA,qBAAA;EACA,yCAAA;EACA,wBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,uCAAA;EACA,sBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,wCAAA;EACA,uBAAA;AALJ;;AAQA;EACI,kCAAA;EACA,uCAAA;EACA,sBAAA;EACA,wCAAA;EACA,uBAAA;AALJ;;AAQA;EACI,kBAAA;AALJ;;AAQA;EACI,2BAAA;AALJ;;AAQA;EACI,4BAAA;AALJ;;AAQA;EACI,2BAAA;EACA,4BAAA;AALJ;;AAQA;EACI,8BAAA;AALJ;;AAQA;EACI,+BAAA;AALJ;;AAQA;EACI,8BAAA;EACA,+BAAA;AALJ;;AAQA;EACI,2BAAA;EACA,8BAAA;AALJ;;AAQA;EACI,4BAAA;EACA,+BAAA;AALJ;;AAQA;EACI,kBAAA;AALJ;;AAQA;EACI,2BAAA;AALJ;;AAQA;EACI,4BAAA;AALJ;;AAQA;EACI,2BAAA;EACA,4BAAA;AALJ;;AAQA;EACI,8BAAA;AALJ;;AAQA;EACI,+BAAA;AALJ;;AAQA;EACI,8BAAA;EACA,+BAAA;AALJ;;AAQA;EACI,2BAAA;EACA,8BAAA;AALJ;;AAQA;EACI,4BAAA;EACA,+BAAA;AALJ","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Border UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n:root {\n    --ezBorderColorBlack: var(--ezClockerBlack);\n    --ezBorderColorGray: var(--ezClockerGray);\n    --ezBorderColorStone: var(--ezClockerStone);\n    --ezBorderColorSilver: var(--ezClockerSilver);\n    --ezBorderColorOffWhite: var(--ezClockerOffWhite);\n    --ezBorderColorNavy: var(--ezClockerNavy);\n    --ezBorderStyle: solid;\n    --ezBorderWidth: 1px;\n    --ezBorderRadius: 3px;\n    --ezBorderMedium: 3px;\n    --ezBorderMediumRadius: 3px;\n    --ezBorderThick: 4px;\n    --ezBorderThickRadius: 3px;\n}\n\n.ezBorders-radius {\n    border-radius: var(--ezBorderRadius);\n}\n\n.ezBorders-top-radius {\n    border-top-left-radius: var(--ezBorderRadius);\n    border-top-right-radius: var(--ezBorderRadius);\n}\n\n.ezBorders-bottom-radius {\n    border-bottom-left-radius: var(--ezBorderRadius);\n    border-bottom-right-radius: var(--ezBorderRadius);\n}\n\n\n/* 1px borders */\n.ezBorder {\n    border-color: var(--ezBorderColorGray);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderWidth);\n}\n\n.ez-border-rounded {\n    border-color: var(--ezBorderColorGray);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderWidth);\n    border-radius: var(--ezBorderRadius);\n}\n\n.ez-border-navy {\n    border-color: var(--ezBorderColorNavy);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderWidth);\n    border-radius: var(--ezBorderRadius);\n}\n\n.ez-border-navy-2px {\n    border-color: var(--ezBorderColorNavy);\n    border-style: var(--ezBorderStyle);\n    border-width: 2px;\n    border-radius: var(--ezBorderRadius);\n}\n\n.ez-border-medium-navy {\n    border-color: var(--ezBorderColorNavy);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderMedium);\n    border-radius: var(--ezBorderRadius);\n}\n\n.ez-border-medium-rounded-navy {\n    border-color: var(--ezBorderColorNavy);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderMedium);\n    border-radius: var(--ezBorderRadius);\n}\n\n.ez-border-medium-rounded-right-navy {\n    border-color: var(--ezBorderColorNavy);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderMedium);\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: var(--ezBorderRadius);\n    border-bottom-right-radius: var(--ezBorderRadius);\n}\n\n.ez-border-thick-navy {\n    border-color: var(--ezBorderColorNavy);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderThick);\n    border-radius: var(--ezBorderRadius);\n}\n\n.ezBorders_Stone {\n    border-color: var(--ezBorderColorStone);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderWidth);\n}\n\n.ezBorders_Silver {\n    border-color: var(--ezBorderColorStone);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderWidth);\n}\n\n.ezBorders_OffWhite {\n    border-color: var(--ezBorderColorStone);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderWidth);\n}\n\n.ezBorderLeft {\n    border-color: var(--ezClockerGray);\n    border-left-style: var(--ezBorderStyle);;\n    border-left-width: var(--ezBorderWidth);\n}\n\n.ezBorderLeftBottom {\n    border-color: var(--ezClockerGray);\n\n    /* border-left-style: var(--ezBorderStyle); */\n    border-left-style: var(--ezBorderStyle);;\n\n    /* border-left-width: var(--ezBorderWidth) */\n    border-left-width: var(--ezBorderWidth);\n\n    /* border-bottom-style: var(--ezBorderStyle); */\n    border-bottom-style: var(--ezBorderStyle);;\n\n    /* border-bottom-width: var(--ezBorderWidth) */\n    border-bottom-width: var(--ezBorderWidth);\n}\n\n.ezBorderRight {\n    border-color: var(--ezClockerGray);\n    border-right-style: var(--ezBorderStyle);;\n    border-right-width: var(--ezBorderWidth);\n}\n\n.ezBorderBottom {\n    border-color: var(--ezClockerGray);\n    border-right-style: var(--ezBorderStyle);;\n    border-right-width: var(--ezBorderWidth);\n    border-bottom-style: var(--ezBorderStyle);;\n    border-bottom-width: var(--ezBorderWidth);\n}\n\n.ezBorderLeftRightBottom {\n    border-color: var(--ezClockerGray);\n    border-left-style: var(--ezBorderStyle);;\n    border-left-width: var(--ezBorderWidth);\n    border-right-style: var(--ezBorderStyle);;\n    border-right-width: var(--ezBorderWidth);\n    border-bottom-style: var(--ezBorderStyle);;\n    border-bottom-width: var(--ezBorderWidth);\n}\n\n.ezSolidBorder1 {\n    border-color: var(--ezClockerGray);\n    border-style: var(--ezBorderStyle);;\n    border-width: var(--ezBorderWidth);\n}\n\n.ezSolidBorderTop1 {\n    border-color: var(--ezClockerGray);\n    border-top-style: var(--ezBorderStyle);;\n    border-top-width: var(--ezBorderWidth);\n}\n\n.ezSolidBorderBottom1 {\n    border-color: var(--ezClockerGray);\n    border-bottom-style: var(--ezBorderStyle);;\n    border-bottom-width: var(--ezBorderWidth);\n}\n\n.ezSolidBorderTopBottom1 {\n    border-color: var(--ezClockerGray);\n    border-top-style: var(--ezBorderStyle);;\n    border-top-width: var(--ezBorderWidth);\n    border-bottom-style: var(--ezBorderStyle);;\n    border-bottom-width: var(--ezBorderWidth);\n}\n\n.ezSolidBorderLeft1 {\n    border-color: var(--ezClockerGray);\n    border-left-style: var(--ezBorderStyle);;\n    border-left-width: var(--ezBorderWidth);\n}\n\n.ezSolidBorderRight1 {\n    border-color: var(--ezClockerGray);\n    border-right-style: var(--ezBorderStyle);;\n    border-right-width: var(--ezBorderWidth);\n}\n\n.ezSolidBorderLeftRigt1 {\n    border-color: var(--ezClockerGray);\n    border-left-style: var(--ezBorderStyle);;\n    border-left-width: var(--ezBorderWidth);\n    border-right-style: var(--ezBorderStyle);;\n    border-right-width: var(--ezBorderWidth);\n}\n\n/* 2px borders */\n.ezSolidBorder2 {\n    border-color: var(--ezClockerGray);\n    border-style: var(--ezBorderStyle);;\n    border-width: 2px;\n}\n\n.ezSolidBorderTop2 {\n    border-color: var(--ezClockerGray);\n    border-top-style: var(--ezBorderStyle);;\n    border-top-width: 2px;\n}\n\n.ezSolidBorderBottom2 {\n    border-color: var(--ezClockerGray);\n    border-bottom-style: var(--ezBorderStyle);;\n    border-bottom-width: 2px;\n}\n\n.ezSolidBorderTopBottom2 {\n    border-color: var(--ezClockerGray);\n    border-top-style: var(--ezBorderStyle);;\n    border-top-width: 2px;\n    border-bottom-style: var(--ezBorderStyle);;\n    border-bottom-width: 2px;\n}\n\n.ezSolidBorderLeft2 {\n    border-color: var(--ezClockerGray);\n    border-left-style: var(--ezBorderStyle);;\n    border-left-width: 2px;\n}\n\n.ezSolidBorderRight2 {\n    border-color: var(--ezClockerGray);\n    border-right-style: var(--ezBorderStyle);;\n    border-right-width: 2px;\n}\n\n.ezSolidBorderLeftRigt2 {\n    border-color: var(--ezClockerGray);\n    border-left-style: var(--ezBorderStyle);;\n    border-left-width: 2px;\n    border-right-style: var(--ezBorderStyle);;\n    border-right-width: 2px;\n}\n\n/* 4px borders */\n.ezSolidBorder4 {\n    border-color: var(--ezClockerGray);\n    border-style: var(--ezBorderStyle);;\n    border-width: 4px;\n}\n\n.ezSolidBorderTop4 {\n    border-color: var(--ezClockerGray);\n    border-top-style: var(--ezBorderStyle);;\n    border-top-width: 4px;\n}\n\n.ezSolidBorderBottom4 {\n    border-color: var(--ezClockerGray);\n    border-bottom-style: var(--ezBorderStyle);;\n    border-bottom-width: 4px;\n}\n\n.ezSolidBorderTopBottom4 {\n    border-color: var(--ezClockerGray);\n    border-top-style: var(--ezBorderStyle);;\n    border-top-width: 4px;\n    border-bottom-style: var(--ezBorderStyle);;\n    border-bottom-width: 4px;\n}\n\n.ezSolidBorderLeft4 {\n    border-color: var(--ezClockerGray);\n    border-left-style: var(--ezBorderStyle);;\n    border-left-width: 4px;\n}\n\n.ezSolidBorderRight4 {\n    border-color: var(--ezClockerGray);\n    border-right-style: var(--ezBorderStyle);;\n    border-right-width: 4px;\n}\n\n.ezSolidBorderLeftRigt4 {\n    border-color: var(--ezClockerGray);\n    border-left-style: var(--ezBorderStyle);;\n    border-left-width: 4px;\n    border-right-style: var(--ezBorderStyle);;\n    border-right-width: 4px;\n}\n\n.ezRadius2 {\n    border-radius: 2px;\n}\n\n.ezRadiusTopLeft2 {\n    border-top-left-radius: 2px;\n}\n\n.ezRadisuTopRight2 {\n    border-top-right-radius: 2px;\n}\n\n.ezRadiusTop2 {\n    border-top-left-radius: 2px;\n    border-top-right-radius: 2px;\n}\n\n.ezRadiusBottomLeft2 {\n    border-bottom-left-radius: 2px;\n}\n\n.ezRadisuBottomRight2 {\n    border-bottom-right-radius: 2px;\n}\n\n.ezRadisuBottom2 {\n    border-bottom-left-radius: 2px;\n    border-bottom-right-radius: 2px;\n}\n\n.ezRadiusLeft2 {\n    border-top-left-radius: 2px;\n    border-bottom-left-radius: 2px;\n}\n\n.ezRadiusRight2 {\n    border-top-right-radius: 2px;\n    border-bottom-right-radius: 2px;\n}\n\n.ezRadius4 {\n    border-radius: 4px;\n}\n\n.ezRadiusTopLeft4 {\n    border-top-left-radius: 4px;\n}\n\n.ezRadiusTopRight4 {\n    border-top-right-radius: 4px;\n}\n\n.ezRadiusTop4 {\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n}\n\n.ezRadiusBottomLeft4 {\n    border-bottom-left-radius: 4px;\n}\n\n.ezRadisuBottomRight4 {\n    border-bottom-right-radius: 4px;\n}\n\n.ezRadisuBottom4 {\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n\n.ezRadiusLeft4 {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.ezRadiusRight4 {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
